import { Request } from 'api';
import { AxiosResponse } from 'axios';

export interface ExistingUserOrganization {
    name: string;
    logo: string | null;
}

export interface ExistingUser {
    first_name: string;
    last_name: string;
    created_at: string | null;
    organizations: ExistingUserOrganization[];
    role: 'athlete' | 'coach';
    email: string | null;
    phone: string | null;
    profile_photo: string | null;
}

export interface CheckPhoneExistsResponse {
    exists: boolean;
    matching_users: ExistingUser[];
}

type ReturnType = Promise<AxiosResponse<CheckPhoneExistsResponse>>;

const checkPhoneExists = (phone: string): ReturnType => {
    return Request.post(`/authentication/sms/check-phone-exists`, { phone });
};

export default checkPhoneExists;
